import { cn } from "@/utils";
import type { SeoImage } from "../types";

type SeoPictureProps = {
  image: SeoImage;
  /** Imagem da primeira dobra: carrega já e com prioridade (é o LCP). */
  priority?: boolean;
  sizes: string;
  className?: string;
};

/**
 * Imagem otimizada da LP: WebP em várias larguras, `width`/`height` declarados
 * para o navegador reservar o espaço (sem CLS). Os arquivos `<src>-<w>.webp`
 * saem do estúdio de mídia já no tamanho certo.
 */
export const SeoPicture = ({
  image,
  priority = false,
  sizes,
  className,
}: SeoPictureProps) => {
  const largest = Math.max(...image.widths);

  return (
    <img
      src={`${image.src}-${largest}.webp`}
      srcSet={image.widths.map(w => `${image.src}-${w}.webp ${w}w`).join(", ")}
      sizes={sizes}
      alt={image.alt}
      width={image.width}
      height={image.height}
      loading={priority ? "eager" : "lazy"}
      fetchPriority={priority ? "high" : "auto"}
      decoding="async"
      className={cn("h-auto w-full", className)}
    />
  );
};
